/**
 * @generated SignedSource<<99b7c0eaea47b06b6230715cdce7e99e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type fetchCurrentCompanyQuery$variables = {
  companyId: string;
};
export type fetchCurrentCompanyQuery$data = {
  readonly companyById: {
    readonly id: string;
    readonly rowId: any;
    readonly name: string;
    readonly legalName: string | null;
  } | null;
};
export type fetchCurrentCompanyQuery = {
  variables: fetchCurrentCompanyQuery$variables;
  response: fetchCurrentCompanyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "companyId"
      }
    ],
    "concreteType": "Company",
    "kind": "LinkedField",
    "name": "companyById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "legalName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchCurrentCompanyQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchCurrentCompanyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a7f627c6d7b74b191f9277b61f4c5b9",
    "id": null,
    "metadata": {},
    "name": "fetchCurrentCompanyQuery",
    "operationKind": "query",
    "text": "query fetchCurrentCompanyQuery(\n  $companyId: ID!\n) {\n  companyById(id: $companyId) {\n    id\n    rowId\n    name\n    legalName\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a02c9d1aecb16b8366d9ccb973d9f2b";

export default node;
